import React from 'react';
import {
  EXCLUDE_TAB_LABEL,
  EXCLUDE_TAB_OPTIONAL_HINT,
  EXCLUDE_TAB_SELECTED_SUFFIX,
} from './segment-picker-copy';
import { getSegmentPickerPanelId, getSegmentPickerTabId } from './segment-picker-ids';
import styles from './SegmentPicker.module.css';

export type SegmentPickerTab = 'include' | 'exclude';

interface SegmentPickerTabsProps {
  pickerId: string;
  activeTab: SegmentPickerTab;
  onChange: (tab: SegmentPickerTab) => void;
  includeLabel: string;
  exclusionCount: number;
}

export const SegmentPickerTabs: React.FC<SegmentPickerTabsProps> = ({
  activeTab,
  onChange,
  includeLabel,
  exclusionCount,
  pickerId,
}) => {
  const panelId = getSegmentPickerPanelId(pickerId);
  const hasExclusions = exclusionCount > 0;
  const excludeHint = hasExclusions
    ? `${exclusionCount} ${EXCLUDE_TAB_SELECTED_SUFFIX}`
    : EXCLUDE_TAB_OPTIONAL_HINT;
  return (
    <div role="tablist" className={styles.tabs}>
      <button
        type="button"
        role="tab"
        id={getSegmentPickerTabId(pickerId, 'include')}
        aria-controls={panelId}
        aria-selected={activeTab === 'include'}
        onClick={() => onChange('include')}>
        {includeLabel}
      </button>
      <button
        type="button"
        role="tab"
        id={getSegmentPickerTabId(pickerId, 'exclude')}
        aria-controls={panelId}
        aria-selected={activeTab === 'exclude'}
        onClick={() => onChange('exclude')}>
        {EXCLUDE_TAB_LABEL}
        <small>{excludeHint}</small>
      </button>
    </div>
  );
};
